module.exports = __webpack_public_path__ + "static/media/video02.0d642532.jpg";